import { LitElement, css, html, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { makeCustomEvent, EVENT } from '../util/events';
import { consume } from '@lit/context';
import { breakpointContext } from '../contexts/breakpoint';
import { BREAKPOINT } from '../util/breakpoints';
import { classMap } from 'lit/directives/class-map.js';

@customElement('rq-continue-button')
export class ContinueButton extends LitElement {
    static styles = css`
        .content {
            display: grid;
            grid-template-columns: 1fr 1fr 1fr;
            gap: 4px;
        }
        .icon {
            display: flex;
            justify-content: start;
        }
        .icon-padding {
            padding-top: 1px;
        }
    `;

    @property({ type: Boolean })
    disabled: boolean = false;

    @property({ type: Boolean })
    submit: boolean = false;

    @property()
    analyticsid: string = '';

    @consume({ context: breakpointContext, subscribe: true })
    breakpoint!: BREAKPOINT;

    get isMobile() {
        return this.breakpoint === BREAKPOINT.PHONE || this.breakpoint === BREAKPOINT.TABLET;
    }

    get event(): EVENT {
        return this.submit ? EVENT.SUBMIT : EVENT.NEXT_STEP;
    }

    render() {
        return html`<lh-button
            .disabled=${this.disabled}
            analytics-id=${this.analyticsid || nothing}
            full-width
            @click=${() => this.dispatchEvent(makeCustomEvent(this.event))}
            variant=${'filled'}
        >
            <div class="content">
                <div></div>
                <div>Continue</div>
                <div class=${classMap({ icon: true, 'icon-padding': !this.isMobile })}>
                    <lh-icon size="sm" name="caret-right"> </lh-icon>
                </div>
            </div>
        </lh-button>`;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        'rq-continue-button': ContinueButton;
    }
}
